<template>
	<div>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Jadwal Pengiriman Warehouse</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2 text-capitalize">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<v-col class="px-3">
					<v-row>
						<v-col cols="12" md="3">
							<v-text-field dense outlined hide-details label="Kode Pemesanan" v-model="po_code.value" color="primary"></v-text-field>
						</v-col>
						<v-col cols="12" md="3">
							<v-autocomplete item-text="supplier_name" item-value="supplier_id" outlined dense hide-details v-model="supplier.value" :items="optionSupplier" label="Supplier" color="primary" item-color="primary" no-data-text="Tidak ada data yang sesuai">
							</v-autocomplete>
						</v-col>
						<v-col cols="12" md="3">
							<v-autocomplete item-text="warehouse_name" item-value="warehouse_id" outlined dense hide-details v-model="warehouse.value" :items="optionWarehouse" label="Warehouse" color="primary" item-color="primary" no-data-text="Tidak ada data yang sesuai">
							</v-autocomplete>
						</v-col>
						<v-col cols="12" md="3">
							<v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field outlined dense :value="convertDate(search_date)" label="Jadwal Pengiriman" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hint="Bisa pilih range tanggal" hide-details></v-text-field>
								</template>
								<v-date-picker locale="id" first-day-of-week="0" range color="primary" v-model="search_date"></v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12" md="9" class="text-right">
						</v-col>
						<v-col cols="12" md="3" class="text-right">
							<v-btn @click="resetFilter" outlined color="grey darken-1" class="text-capitalize" dark>Reset</v-btn>
							<v-btn @click="cari" depressed color="primary" dark class="ml-2 text-capitalize">Cari</v-btn>
						</v-col>
					</v-row>
				</v-col>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined>
			<v-data-table loading :headers="headers" :items="scheduleResults" hide-default-footer :options.sync="option" :server-items-length="schedulePagination.total_data" disable-pagination class="table-w-120">
				<template v-slot:item.po_schedule_detail_date="{ item }">
					<div> {{ item.po_schedule_detail_date | tanggal }}</div>
				</template>
				<template v-slot:item.po_code="{ item }">
					<div @click="filterbyCode(item.po_code)"> {{ item.po_code }}</div>
				</template>
				<template v-slot:item.supplier_name="{ item }">
					<div class="py-3">
						<div>{{ item.supplier_name }}</div>
						<div class="pt-1"><v-icon small>mdi-phone</v-icon><span class="pl-2">{{ item.supplier_mobilephone }}</span></div>
						<div class="pt-1"><v-icon small>mdi-map-marker</v-icon><span class="pl-2">{{ item.supplier_address }}</span></div>
					</div>
				</template>
				<template v-slot:item.po_schedule_detail_quantity="{ item }">
					<div> {{ item.po_schedule_detail_quantity | toNumber }}</div>
				</template>
				<template v-slot:item.warehouse_name="{ item }">
					<div class="py-3">
						<div>{{ item.warehouse_name }}</div>
						<div class="pt-1"><v-icon small>mdi-phone</v-icon><span class="pl-2">{{ item.warehouse_mobilephone }}</span></div>
						<div class="pt-1"><v-icon small>mdi-map-marker</v-icon><span class="pl-2">{{ item.warehouse_address }}</span></div>
					</div>
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!schedulePagination">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5">
			<v-row v-if="schedulePagination">
				<v-col cols="12" md="11" class="py-0 d-flex justify-end">
					<v-pagination @input="changePage" :length="schedulePagination.total_page" total-visible="7" circle class="d-flex justify-end" color="primary"></v-pagination>
				</v-col>
				<v-col cols="12" md="1" class="py-0 pl-0">
					<v-autocomplete @input="changelimit" :items="listLimit" v-model="limit" hide-details class="mt-0" label="Item" color="primary" item-color="cyan darken-4"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import {mapActions,  mapState, mapMutations} from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			dropfilter: false,
			dialogDetail: false,
			menu: false,
			page: 1,
			listLimit: [ '5', '10', '20', '50', '100' ],
			limit: '10',
			params: [],
			sortBy: 'po_schedule_detail_date',
			sortDir: 'DESC',
			headers: [
			{ text: 'Tanggal Pengiriman', value: 'po_schedule_detail_date' },
			{ text: 'Kode Pemesanan', value: 'po_code' },
			{ text: 'Produk', value: 'product_name' },
			{ text: 'Jumlah', value: 'po_schedule_detail_quantity' },
			{ text: 'Supplier Pengirim', value: 'supplier_name' },
			{ text: 'Warehouse Tujuan', value: 'warehouse_name' },
			],
			dateCreate: false,
			dateSent: false,
			po_code: {
				value:'',
				comparison:'=',
				type:'string',
				field: 'po_code'
			},
			supplier: {
				value:'',
				comparison:'=',
				type:'string',
				field: 'supplier_id'
			},
			warehouse: {
				value:'',
				comparison:'=',
				type:'string',
				field: 'warehouse_id'
			},
			schedule_date: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'po_schedule_detail_date'
			},
			search_date: [],
			po_id: '',
		}
	},
	computed: {
		...mapState('schedules', ['scheduleResults', 'schedulePagination', 'optionSupplier', 'optionWarehouse']),
	},
	methods: {
		...mapActions('schedules', ['getSchedulesAll', 'exportSchedulesAll', 'getOptionSupplier', 'getOptionWarehouse']),
		...mapMutations('schedules', ['clearDataSchedules']),

		getData() {
			this.getSchedulesAll(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		filterbyCode(val) {
			this.po_code.value = val
			this.dropfilter = true
			this.page = 1
			this.cari()
		},
		exportData(){
			this.exportSchedulesAll(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		resetFilter() {
			this.po_code.value = ''
			this.schedule_date.value = ''
			this.warehouse.value = ''
			this.supplier.value = ''
			this.search_date = []
			this.page = 1
			this.getData()
		},
		cari() {
			this.params = []
			if (this.po_code.value)
				this.params.push(this.po_code)
			if (this.supplier.value)
				this.params.push(this.supplier)
			if (this.warehouse.value)
				this.params.push(this.warehouse)
			if (this.schedule_date.value){
				if (this.schedule_date.value.length > 1) {
					this.schedule_date.value.sort()
					let date = this.schedule_date.value.join('::')
					this.schedule_date.value = date
				}
				this.params.push(Object.assign({}, this.schedule_date))
			}
			this.page = 1
			this.getData()
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changelimit(limit) {
			this.page = 1
			this.limit = limit
			this.getData()
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Jadwal Pengiriman`);
		this.getData()
		this.getOptionSupplier()
		this.getOptionWarehouse()
	},
	beforeDestroy() {
		this.clearDataSchedules()
	},
	watch: {
		search_date(val) {
			this.schedule_date.value = val
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
}
</script>